// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"view-organization"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 3H21V21H3z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M9 6H15V9H9V6Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M6 15H10V18H6V15Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M14 15H18V18H14V15Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 3H21V21H3z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 9V12M8 15V12H16V15M9 6H15V9H9V6ZM6 15H10V18H6V15ZM14 15H18V18H14V15Z","strokeWidth":"props.strokeWidth"}}]}]};

const ViewOrganizationIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'view-organization',
    ref,
    icon: element,
  },
));

ViewOrganizationIcon.displayName = 'ViewOrganizationIcon';

export default ViewOrganizationIcon;
